// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavigationMenuItemsContainer__menu___3xAgI","tpb":"NavigationMenuItemsContainer__tpb___rhAaV","useTPBBimUpdates":"NavigationMenuItemsContainer__useTPBBimUpdates___1kmGl"};